<template>
    <div
        class="mx-auto login-container"
    >
        <div class="project-title">Campaign Manager</div>
        <div class="login-form">
            <div class="login-title">Sign in to start you session</div>
            <v-form
                @keyup.native.enter="enterKeySubmit"
            >
                <v-text-field
                    v-model="username"
                    label="Username"
                    class="form-field"
                    required
                />
                <v-text-field
                    v-model="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    label="Password"
                    hint="Max 18 characters"
                    value=""
                    class="input-group--focused form-field"
                    required
                    @click:append="show = !show"
                />
                <div
                    class="submit-button-wrapper"
                >
                    <v-btn
                        class="login-btn"
                        :loading="dialog"
                        @click="submit"
                    >
                        Sign In
                    </v-btn>
                </div>
            </v-form>
        </div>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </div>
</template>

<script>
    import Alert from '@/components/Alert'
    import userService from '@/services/user-service'
    import store from '@/store'

    export default {
        components: { Alert },
        data() {
            return {
                show: false,
                showAlert: false,
                dialog: false,
                message: '',
                username: '',
                password: '',
                type: null
            }
        },
        watch: {
            showAlert: {
                handler(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        setTimeout(() => { this.showAlert = false }, 7000)
                    }
                }
            }
        },
        methods: {
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
            },
            submit() {
                this.dialog = true
                userService.login({
                    username: this.username,
                    password: this.password
                }).then(resp => {
                    this.dialog = false
                    store.dispatch('login', [resp]).then(() => this.$router.push('/viber'))
                }).catch(error => {
                    this.error = error.response.data.code
                    this.message = error.response.data.message
                    this.setAlert(this.message, 'error')
                    this.dialog = false
                })
            }
        }
    }
</script>

<style scoped>

.login-btn {
    background-color: #367fa9 !important;
    color: #fff !important;
    border: none !important;
    border-radius: 1px solid black !important;
    outline: none !important;
    text-transform: none !important;
}

.error-message {
    display: flex;
    justify-content: center;
    color: red;
    font-weight: bold;
}

.project-title {
    font-size: 30px;
    color: #333;
    text-align: center;
    font-weight: 700;
    margin-top: 150px;
    margin-bottom: 20px;
}

.login-container {
    display: flex;
    flex-direction: column;
    align-self: center;
    padding-bottom: 10vh;
}

.login-title {
    text-align: center;
    margin-bottom: 10px;
    font-size: 14px;
    color: #666;
}

.login-form {
    margin: 0 auto;
    width: 100%;
    max-width: 400px;
    border-radius: 2px;
    background: white;
    color: black;
    padding: 2vh;
}

.form-field {
    width: 90%;
    margin: 0 auto;
}

.submit-button-wrapper {
    display: flex;
    justify-content: start;
    margin-left: 2vh;
}

</style>
